<template>
  <main>
    <v-app :dark="darkMode">
      <confirm ref="confirm"></confirm>
      <loader ref="loader"></loader>
      <v-snackbar
        :timeout="$store.state.snackbar.timeout"
        top
        right
        :color="$store.state.snackbar.color"
        v-model="$store.state.snackbar.show"
      >
        {{ $store.state.snackbar.message }}
        <v-btn flat dark @click.native="hideSnackbar">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
      <!-- <Updater v-if="platform == 'android'" /> -->
      <router-view :key="$route.path"></router-view>
    </v-app>
  </main>
</template>

<script>
import Socket from "@/modules/socket/Socket";
import confirm from "@/components/utils/confirm";
import loader from "@/components/utils/loader";
import { modes, THEME_MODE } from "@/vuex/theme";
// import Updater from "./components/utils/updater.vue";
import { globalData } from "@/providers/global";

export default {
  name: "App",
  components: {
    confirm,
    loader,
    // Updater,
  },
  data() {
    return {
      platform: 'web',
    }
  },
  methods: {
    hideSnackbar() {
      this.$store.commit("hideSnackbar");
    },
    loadTheme() {
      let mode = modes.system;
      let theme = localStorage.getItem(THEME_MODE);
      if (theme) {
        mode = Number(theme);
      }
      this.$store.commit("setThemeMode", mode);
    },
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm;
    this.$root.$loader = this.$refs.loader;
    this.loadTheme();
  },
  computed: {
    darkMode() {
      return this.$store.getters.isDarkMode;
    },
  },
  created() {
    this.platform = globalData.$data.$platform;
    this.$store.dispatch("connectCh");
  },
  destroyed() {
    Socket.disconnect();
  },
};
</script>
<style>
.font-title-bold {
  font-family: "Lato-Bold" !important;
  font-size: 18px !important;
  letter-spacing: 1px !important;
}

html {
  overflow-y: auto !important;
}

.v-btn__content {
  letter-spacing: 0.5px !important;
  text-transform: none !important;
}
</style>
